import { type ChangeEvent, type FC } from 'react';

import DebounceInput from '@/components/UI/DebounceInput';

interface SelectBuilderOptionProps {
  onChange: (value: string, index: number) => void;
  index: number;
  value: string;
}

const SelectBuilderOption: FC<SelectBuilderOptionProps> = ({ onChange, index, value }) => {
  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value, index);
  };

  return (
    <div className="flex items-center w-100" data-test-component="SelectBuilderOption" data-test-element="container">
      <DebounceInput
        handleChange={handleValueChange}
        inputProps={{
          'data-tooltip-content': '',
          value,
          style: { marginBottom: 0 },
        }}
      />
    </div>
  );
};

export default SelectBuilderOption;
